import ADPAcsService from "../../../../../services/admin/ADPAcsService";
import ADPDeptService from "../../../../../services/admin/ADPDeptService";
import ADPMenuService from "../../../../../services/admin/ADPMenuService";


class accessRightService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async findAllAccessRight(recordFilter:any): Promise<any> {
        return await ADPAcsService.findAll(recordFilter);
    }

    async getADPMenuTree(objectId: any): Promise<any> {
        const menuTree = await ADPMenuService.getADPMenuTree(objectId);
        return menuTree ? JSON.parse(menuTree) : null
    }

    async getADPMenuTreeAccess(objectId: any): Promise<any> {
        const menuTree = await ADPMenuService.getADPMenuTreeAccess(objectId);
        return menuTree ? JSON.parse(menuTree) : null
    }

    async getDropdownByObjectType(objectType: string): Promise<any> {
        return await ADPMenuService.getDropdownByObjectType(objectType);
    }

    async getMenuSetDropdownByObjectType(objectType: string): Promise<any> {
        return await ADPMenuService.getDropdownByObjectType(objectType);
    }

    async create(item: any): Promise<any> {
        return await ADPAcsService.create(item);
    }

    async update(item: any): Promise<any> {
        return await ADPAcsService.update(item.accessRoleId, item);
    }

    async getModuleDropdown(): Promise<any> {
        return await ADPDeptService.getDropdown();
    }
    
}

export default new accessRightService();
